import src from "IMAGE";
export default { src, width: 20, height: 20, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
